import Vue from 'vue';
import Router from 'vue-router';
import VueMarkdown from 'vue-markdown';
import Meta from 'vue-meta';

// Core Pages
import ContactMainPage from '@/pages/ContactMain';
import MatterArticlePage from '@/pages/MatterArticle';
import MatterMainPage from '@/pages/MatterMain';
import modulesLayout from '@/pages/modules';
import WorkArticlePage from '@/pages/WorkArticle';
import WorkMainPage from '@/pages/WorkMain';

import HolidayLanding2008 from '@/pages/HolidayLanding2008';

// Components
import PageNotFound from '@/components/PageNotFound';

import modules from '@/modules/index';
import components from '@/components/index';
import pages from '@/content';
import debugs from '@/debug';

// import work from '@/content/work/index';

import contact from '@/content/contact-index';
import matter from '@/content/matter-article-index';
import memeRecords from '@/content/meme-bundle';
import workArticleIndex from '@/content/work-article-index';
import workArticleBundle from '@/content/work-article-bundle';

// Utils
import { shuffleArray } from '@/utils/data-utils';

// register all modules & components
for (const module in modules) {
  Vue.component(`module_${module}`, modules[module]);
}

for (const component in components) {
  Vue.component(`component_${component}`, components[component]);
}

for (const debug in debugs) {
  Vue.component(`debug_${debug}`, debugs[debug]);
}

Vue.component('markdown', VueMarkdown);

Vue.use(Router);
Vue.use(Meta);

export default new Router({
  mode: 'history',
  routes: [
    // Misc Routes
    {
      path: '/2018-holiday-thank-you',
      name: 'holiday-landing-2008',
      component: HolidayLanding2008,
    },
    // Core website routes
    {
      path: '/',
      name: 'homepage',
      component: modulesLayout,
      props: {
        page: 'homepage',
        data: pages.homepage,
      },
    },
    {
      path: '/contact',
      name: 'contact-main',
      component: ContactMainPage,
      props: {
        page: 'contact',
        data: contact,
      },
    },
    {
      path: '/matter',
      name: 'matter-main',
      component: MatterMainPage,
      props: {
        page: 'matter',
        data: matter,
      },
    },
    {
      path: '/matter/:slug',
      name: 'matter-article',
      component: MatterArticlePage,
      beforeEnter(to, from, next) {
        const { slug } = to.params;
        const { articles } = matter;

        const found = articles.filter(function(article) {
          return (article.slug === slug);
        });
        const haveArticle = (found.length !== 0);
        if (haveArticle) {
          next();
        } else {
          next({ name: 'page-not-found', params: [to.path], replace: true });
        }
      },
      props: (route) => {
        const { origin, href } = location;
        const { path, params } = route;
        const { slug } = params;
        return { slug, path, origin, href };
      },
    },
    {
      path: '/work',
      name: 'work-main',
      component: WorkMainPage,
      props: {
        data: workArticleIndex,
      },
    },
    {
      path: '/work/:slug',
      name: 'work-article',
      component: WorkArticlePage,
      beforeEnter(to, from, next) {
        const { slug } = to.params;

        const haveArticle = (workArticleBundle[slug] !== undefined);
        if (haveArticle) {
          next();
        } else {
          next({ name: 'page-not-found', params: [to.path], replace: true });
        }
      },
      props: (route) => {
        const { path: url, params } = route;
        const { slug } = params;
        return { slug, url, workArticles: workArticleBundle };
      },
    },
    {
      // TODO: remove this once '/about' has own route
      path: '/:slug',
      name: 'L2',
      component: modulesLayout,
      beforeEnter(to, from, next) {
        const { slug } = to.params;
        const validPageSlugs = ['about'];

        const havePage = (validPageSlugs.includes(slug));
        if (havePage) {
          next();
        } else {
          next({ name: 'page-not-found', params: [to.path], replace: true });
        }
      },
      props: (route) => {
        const { slug } = route.params;
        return {
          page: slug,
          data: pages[slug],
        };
      },
    },
    {
      path: '*',
      name: 'page-not-found',
      component: PageNotFound,
      props: () => {
        const list = shuffleArray(memeRecords);
        const idx = Math.floor(Math.random() * list.length);
        return {
          data: list[idx],
        };
      },
    },
  ],
  scrollBehavior (to, from, savedPosition) {
    if (to.hash) {
      return { selector: to.hash };
    }

    if (savedPosition) {
      return savedPosition;
    }

    return { x: 0, y: 0 };
  },
});



// WEBPACK FOOTER //
// ./src/router/index.js